import { Component, OnInit } from '@angular/core';
import { AuthService } from '@fapp/authentication';
import { RootMixin, UserAwareMixin } from '@fapp/mixins';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
  standalone: false,
})
export class UserMenuComponent
  extends UserAwareMixin(RootMixin)
  implements OnInit
{
  luser: Observable<any>;
  constructor(private auth: AuthService) {
    super();
  }

  ngOnInit(): void {
    this.luser = this.currentUser.valueChanges.pipe(
      map((res: any) => res.data.currentUser)
    );
  }

  logout() {
    this.auth.logout();
  }

  formatExpirationDate(dateString: string): string {
    if (!dateString) return '';

    const date = new Date(dateString);
    const now = new Date();
    const daysRemaining = Math.ceil(
      (date.getTime() - now.getTime()) / (1000 * 60 * 60 * 24)
    );

    // Format the date as DD/MM/YYYY
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    const formattedDate = `${day}/${month}/${year}`;

    // Add warning color if expiring soon
    if (daysRemaining <= 7 && daysRemaining > 0) {
      return `${formattedDate} (${daysRemaining} days left)`;
    } else if (daysRemaining <= 0) {
      return `${formattedDate} (Expired)`;
    }

    return formattedDate;
  }

  isExpired(dateString: string): boolean {
    if (!dateString) return false;
    const date = new Date(dateString);
    const now = new Date();
    return date.getTime() <= now.getTime();
  }

  isExpiringSoon(dateString: string): boolean {
    if (!dateString) return false;
    const date = new Date(dateString);
    const now = new Date();
    const daysRemaining = Math.ceil(
      (date.getTime() - now.getTime()) / (1000 * 60 * 60 * 24)
    );
    return daysRemaining <= 7 && daysRemaining > 0;
  }
}
